import { useWizard } from "@picklebet/ui";
import { convertAmountToCents } from "common/currency";
import { walletService } from "@/features/wallet/services/wallet";
import { useBankAccount } from "@/hooks/firestore/user/useBankAccounts";
import { err } from "utilities/result";
import type { WithdrawStepName } from "../utils/registry";

/**
 * Submitting lives here rather than in the form because the OTP step also
 * submits: `Wizard.Step` unmounts its children when it stops being active, so
 * the form cannot hold the pending withdrawal across the verification step.
 */
export const useAudWithdrawal = () => {
  const { goTo } = useWizard<WithdrawStepName>();
  const { bankAccount } = useBankAccount();

  const submit = async (amount: number, verificationRequestId?: string) => {
    if (!bankAccount) {
      return err(new Error("No bank account is saved for this account"));
    }

    const result = await walletService.withdrawCash({
      amount: convertAmountToCents(amount),
      currency: "AUD",
      bankAccountId: bankAccount.id,
      userExternalWalletId: bankAccount.userExternalWalletId,
      externalType: "AUD_BANK_ACCOUNT",
      verificationRequestId,
    });

    if (result.ok) {
      goTo("withdraw-success", { replace: true });
    }

    return result;
  };

  return { submit, bankAccount };
};
